const ICONS = {
    duration: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="56" height="56" fill="none" stroke="#ff5149" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="32" cy="32" r="30"></circle><path d="M44 26a13 13 0 0 0-23-2"></path><polyline points="20,17 21,24 28,23"></polyline><path d="M20 38a13 13 0 0 0 23 2"></path><polyline points="44,47 43,40 36,41"></polyline><path d="M35 27.5c-.8-1.4-2.2-2.2-3.9-2.2-2.3 0-3.9 1.3-3.9 3.1 0 1.6 1.1 2.5 3.5 3l1.6.4c2.4.5 3.7 1.5 3.7 3.3 0 2-1.8 3.3-4.3 3.3-1.9 0-3.5-.9-4.2-2.4"></path><line x1="31.5" y1="23" x2="31.5" y2="41"></line></svg>`,
    career: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="56" height="56" fill="none" stroke="#ff5149" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="32" cy="32" r="30"></circle><rect x="21" y="18" width="22" height="28" rx="2"></rect><rect x="24" y="22" width="16" height="5" rx="1"></rect><circle cx="26.5" cy="32" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="32" cy="32" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="37.5" cy="32" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="26.5" cy="37" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="32" cy="37" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="37.5" cy="37" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="26.5" cy="42" r="1.2" fill="#ff5149" stroke="none"></circle><circle cx="32" cy="42" r="1.2" fill="#ff5149" stroke="none" data-tsd-source="/src/routes/index.tsx:62:7"></circle><circle cx="37.5" cy="42" r="1.2" fill="#ff5149" stroke="none" data-tsd-source="/src/routes/index.tsx:63:7"></circle></svg>`,
    mentorship: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="56" height="56" fill="none" stroke="#ff5149" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><circle cx="32" cy="32" r="30"></circle><circle cx="32" cy="24" r="4"></circle><path d="M24 38c0-4.4 3.6-8 8-8s8 3.6 8 8"></path><circle cx="22" cy="30" r="3.2"></circle><path d="M16 44c0-3.6 2.7-6.5 6-6.5"></path><circle cx="42" cy="30" r="3.2"></circle><path d="M48 44c0-3.6-2.7-6.5-6-6.5"></path><path d="M25 46c0-3.9 3.1-7 7-7s7 3.1 7 7"></path></svg>`,
    scope: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="56" height="56" fill="none" stroke="#ff5149" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="32" cy="32" r="30"></circle><path d="M32 15 L29 20 L32 19 L35 20 Z"></path><path d="M28 20 L26 24 L30 22 Z"></path><path d="M36 20 L38 24 L34 22 Z"></path><rect x="24" y="23" width="16" height="24" rx="1.5"></rect><path d="M25 29 q1.5 -2 3 0 t3 0 t3 0 t3 0"></path><path d="M25 35 q1.5 -2 3 0 t3 0 t3 0 t3 0"></path><path d="M25 41 q1.5 -2 3 0 t3 0 t3 0 t3 0"></path></svg>`
}

export const page = {
    title: 'Kevin Ladner Legacy Scholarship',
    sections: [
        {
            acf_fc_layout: 'image_banner',
            title: 'Kevin Ladner Legacy Scholarship',
            background: '#f5f2ef',
            hasLogo: 'yes',
            styled: 'yes',
            image: {
                url: '/static/landing/kevin-ladner.jpg',
                sizes: {
                    large: '/static/landing/kevin-ladner.jpg',
                    medium_large: '/static/landing/kevin-ladner-xs.jpg',
                }
            },
            text: `<p>A scholarship honouring Kevin Ladner's legacy of purpose-driven leadership, community impact, and support for the next generation of accounting professionals.</p>`
        },
        {
            acf_fc_layout: 'section_text',
            background: '#fff0',
            title: 'Amazing Lives, Rewarding Careers',
            text: `<p>The Amazing Lives, Rewarding Careers: Kevin Ladner Legacy Scholarship honours and celebrates the lasting impact that retiring CEO and Executive Partner Kevin Ladner has had on our Firm, our communities, and the accounting profession. Established in 2026 by the Doane Grant Thornton Foundation, the scholarship reflects Kevin's belief in giving back, creating opportunities for others, and supporting future generations of CPAs.</p>`
        },
        {
            acf_fc_layout: 'section_text',
            background: '#fff0',
            title: 'Background & Purpose',
            text: `<p>The scholarship recognizes Kevin's values-based leadership, his commitment to community, and his dedication to helping others succeed. Awarded annually to accounting students at participating schools across Canada, it supports individuals who demonstrate academic excellence and a meaningful commitment to their communities. Through this investment, the Foundation aims to help develop future professionals who will create positive impact wherever they live and work.</p>`
        },
        {
            acf_fc_layout: 'section_statistics',
            title: 'Over the next 10 years',
            background: '#fff0',
            items: [
                {
                    title: '$750,000',
                    text: 'in scholarships awarded'
                },
                {
                    title: '150',
                    text: 'students supported'
                },
                {
                    title: '15',
                    text: 'universities from coast to coast'
                },
            ]
        },
        {
            acf_fc_layout: 'section_text_and_icons',
            background: '#fff0',
            title: 'More than a scholarship',
            styled: 'yes',
            items_count: 3,
            items: [
                {
                    icon: getIconByLabel('Duration'),
                    title: 'Impact',
                    text: 'Every year for the next 10 years, one 3rd or 4th year student from each of the 15 participating schools will receive a $5,000 scholarship from the Foundation.',
                },
                {
                    icon: getIconByLabel('Career'),
                    title: 'Career Pathways',
                    text: 'Recipients will be guaranteed an interview for a co-op, internship, or new graduate opportunity with Doane Grant Thornton, helping them explore career pathways within the profession.'
                },
                {
                    icon: getIconByLabel('Mentorship'),
                    title: 'Mentorship Opportunities',
                    text: 'Recipients will participate in a firm-supported development opportunity that includes learning experiences, connections with mentors, and opportunities to engage with peers and Firm leaders.'
                },
            ]
        },
        {
            acf_fc_layout: 'section_dropdowns',
            background: '#fff0',
            title: 'Selection criteria',
            text: "Throughout his career, Kevin Ladner championed the importance of giving back to the community, building lasting relationships, and supporting the next generation of accounting professionals. This scholarship carries those values forward by recognizing students who excel academically while making a meaningful difference in their communities.",
            items: [
                {
                    title: 'Academic achievement',
                    text: 'A commitment to academic excellence and a drive to continuously learn and grow.'
                },
                {
                    title: 'Demonstrated community impact',
                    text: 'A demonstrated commitment to helping others, contributing to their community, and creating positive impact through leadership and service.'
                },
                {
                    title: 'List of all participating schools',
                    text: `<ol>
                        <li>Brock University</li>
                        <li>Camosun College</li>
                        <li>Dalhousie University</li>
                        <li>Lakehead University</li>
                        <li>MacEwan University</li>
                        <li>Memorial University of Newfoundland</li>
                        <li>Okanagan College</li>
                        <li>Saint Mary's University</li>
                        <li>Simon Fraser University</li>
                        <li>Toronto Metropolitan University</li>
                        <li>University of Calgary</li>
                        <li>University of New Brunswick</li>
                        <li>University of Prince Edward Island</li>
                        <li>University of Saskatchewan</li>
                        <li>University of Winnipeg</li>
                    </ol>`
                },
            ]
        },
        {
            acf_fc_layout: 'section_text',
            background: '#f5f2ef',
            title: 'How to Apply',
            text: `<p>Recipients are selected through their participating college or university. Please contact your school’s scholarships, financial aid, or student awards office to learn about eligibility, the selection process, and how to be considered for a Kevin Ladner Legacy Scholarship.</p>`
        },
    ]
}

function getIconByLabel(label) {
    const icon = ICONS[label.toLowerCase()]
    if (!icon) {
        return {}
    }
    return {
        url: `data:image/svg+xml;base64,${btoa(icon)}`,
    }
}
